import type { TimeIntervalFormat } from './string';

/**
 * Поле ввода границ у отбора-интервала. Границы уезжают числом секунд, поэтому от записи
 * ввода отбор не зависит, а сама запись — `чч:мм:сс`: у `мм:сс` кит ограничивает минуты 59,
 * то есть границу от часа в нём не задать, а уже заданную он теряет — сохранённые 5445 с
 * показал бы как `30:45` вместо `1:30:45`.
 */
export const TIME_RANGE_FILTER = {
  type: 'time-range',
  returnType: 'seconds',
  timeFormat: 'HH:MM:SS',
} as const;

/** Конфиг поля времени, которым вводятся границы отбора по интервалу */
export type TimeRangeFilter = typeof TIME_RANGE_FILTER;

/**
 * Поле времени для границ отбора по интервалу, показанному в формате `timeFormat`; `null` —
 * границы вводятся числом (интервал показан числом секунд либо интервалом не является).
 *
 * Правило выбора одно на все отборы-интервалы: и на колонку атрибута, и на колонку-поле
 * записи (длительность разговора). Второй экземпляр этого конфига заводить нельзя — он
 * разойдётся с первым.
 */
export const getTimeRangeFilter = (timeFormat: TimeIntervalFormat | null): TimeRangeFilter | null =>
  timeFormat === 'TIME' ? TIME_RANGE_FILTER : null;
